import type { SelectableBasket } from "@eu.mdotm.api/sphere";
import { atomWithStorage, useAtom } from "@mdotm/shadcn/legacy/reactivity";
import type { Updater } from "@mdotm/shadcn/legacy/utils";
import type { TagFilter } from "./SidePanelColumnFilters";

export type InstrumentCustomisationStoreProps = {
	expanded: boolean;
	search: string;
	selectedfilters: Array<[string, TagFilter]>;
	selectedBaskets: Array<SelectableBasket>;
};

export const instrumentCustomisationDefault: InstrumentCustomisationStoreProps = {
	expanded: true,
	selectedfilters: [],
	selectedBaskets: [],
	search: "",
};

export const instrumentCustomisation$ = atomWithStorage<InstrumentCustomisationStoreProps>(
	"instrumentCustomisationAtom",
	instrumentCustomisationDefault,
);

export function useInstrumentCustomisationState(): {
	instrumentCustomisationStore: InstrumentCustomisationStoreProps;
	setInstrumentCustomisationStore: (
		newValue: InstrumentCustomisationStoreProps | Updater<InstrumentCustomisationStoreProps>,
	) => void;
	reset(): void;
} {
	const [instrumentCustomisationStore, setInstrumentCustomisationStore] = useAtom(instrumentCustomisation$);
	return {
		instrumentCustomisationStore,
		setInstrumentCustomisationStore,
		reset: () => setInstrumentCustomisationStore(instrumentCustomisationDefault),
	};
}
